import { DAY_MS } from "./freshness.js";
import type { PRsByExercise } from "./pr.js";

// Pure selector for the Home "recent PRs" strip (kept free of native imports
// so it's unit-testable and shared by mobile + the web-rnw console). The
// records map is keyed exerciseId -> repMax -> PRRecord; we surface one chip
// per exercise (freshest, then heaviest) within a recency window, newest
// first. Empty result hides the strip.

export type RecentPr = {
  exerciseId: string;
  repMax: number;
  weightKg: number;
  setAt: string;
};

export function recentPrs(
  records: PRsByExercise | null | undefined,
  nowMs: number,
  opts: { limit?: number; windowDays?: number } = {},
): RecentPr[] {
  if (!records) return [];
  const { limit = 6, windowDays = 30 } = opts;
  const cutoff = nowMs - windowDays * DAY_MS;

  const bestByExercise = new Map<string, RecentPr>();
  for (const [exerciseId, byRep] of Object.entries(records)) {
    for (const [repStr, rec] of Object.entries(byRep)) {
      const ts = Date.parse(rec.setAt);
      if (Number.isNaN(ts) || ts < cutoff) continue;
      const candidate: RecentPr = {
        exerciseId,
        repMax: Number(repStr),
        weightKg: rec.weightKg,
        setAt: rec.setAt,
      };
      const cur = bestByExercise.get(exerciseId);
      if (
        !cur ||
        ts > Date.parse(cur.setAt) ||
        (ts === Date.parse(cur.setAt) && candidate.weightKg > cur.weightKg)
      ) {
        bestByExercise.set(exerciseId, candidate);
      }
    }
  }

  return [...bestByExercise.values()]
    .sort((a, b) => Date.parse(b.setAt) - Date.parse(a.setAt))
    .slice(0, limit);
}
